import { SyntheticEvent, createContext, useContext } from 'react';
import {
  TabNavigationOptions,
  useTabNavigation,
} from './inc-page-tab-panels.hooks';

export type TabPanel = {
  label: string;
  path: string;
  /** Optional one-liner shown in a click-to-open ⓘ popover inside the tab. */
  tooltip?: string;
};

type IncPageTabPanelsProviderType = {
  children: React.ReactNode;
  tabs: TabPanel[];
  options?: TabNavigationOptions;
};

type IncPageTabPanelsContextType = {
  tabs: TabPanel[];
  tabIndex: number;
  tabLabel: string;
  tabPath: string;
  handleTabChange: (
    _event: SyntheticEvent<Element, Event>,
    newIndex: number,
  ) => void;
};

export const IncPageTabPanelsContext =
  createContext<IncPageTabPanelsContextType>(null);

export const IncPageTabPanelsProvider = ({
  children,
  tabs,
  options,
}: IncPageTabPanelsProviderType) => {
  const { tabIndex, tabLabel, tabPath, handleTabChange } = useTabNavigation({
    tabs,
    options,
  });

  return (
    <IncPageTabPanelsContext.Provider
      value={{ tabs, tabIndex, tabLabel, tabPath, handleTabChange }}
    >
      {children}
    </IncPageTabPanelsContext.Provider>
  );
};

export const useIncPageTabPanelsContext = () =>
  useContext(IncPageTabPanelsContext);
